import { render } from "./BasicLayout.vue?vue&type=template&id=34829850"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
script.render = render

export default script